import PropTypes from 'prop-types';

import CrossCircleIcon from '../../icons/cross-circle.svg';
import cssGlobals from '../../main/css/globals';
import { classList } from '../../utils';
import Icon from '../Icon';
import styles from './styles.scss';

Pill.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  onCrossClick: PropTypes.func,
  variant: PropTypes.oneOf(['regular', 'outline', 'golden']),
};

/**
 * A little colored label or tag with rounded corners. Optionally with a cross
 * button to the right.
 */
export default function Pill({
  children,
  color = cssGlobals['g-grey-boba'],
  onCrossClick,
  variant = 'regular',
}) {
  const Element = onCrossClick ? 'button' : 'span';
  const props = {
    type: Element === 'button' ? 'button' : undefined,
    className: classList({
      [styles[variant]]: true,
      [styles.hasCrossButton]: Element === 'button',
    }),
    style: variant === 'outline' ? { color } : { background: color },
    onClick: Element === 'button' ? onCrossClick : undefined,
  };

  return (
    <Element {...props}>
      {children}
      {Element === 'button' && (
        <span className={styles.crossButton}>
          <Icon icon={CrossCircleIcon} />
        </span>
      )}
    </Element>
  );
}
